.filter {
    display: none;
    &.open {
        display: flex;
        flex-wrap: wrap;
    }

    .filterItem {
        padding: 1rem;
        border-bottom: 1px solid #efefef;
        width: 100%;
    }
    .filterItem.half {
        width: 50%;
    }

    .filterItem.moreClosed,
    .filterItem:last-child {
        border-bottom: 0px solid #dfdfdf;
    }
    .filterItem.hidden {
        display: none;
    }

    .fitlerItemLabel {
        display: block;
        padding-bottom: 0.5rem;
    }

    .spaceTop {
        padding-top: 1rem;
    }

    .checkboxes {
        display: flex;

        > div {
            width: 100%;
            max-width: 100%;
            flex-grow: 1;
        }

        > label {
            display: flex;
            align-items: center;
            margin-right: 1.5rem;
            cursor: pointer;
            span {
                font-weight: 400;
                padding-left: 0.3rem;
                padding-bottom: 0.1rem;
            }
        }

        &.stacked {
            flex-direction: column;
            > label {
                padding: 0.25rem 0;
            }
        }
    }

    .moreButton {
        appearance: none;
        background: transparent;
        border: 0;
        cursor: pointer;
        padding: 0.5rem 0;
        text-align: left;
        width: 100%;
        font-size: 0.875rem;
        font-weight: 600;
        color: #14456b;
    }

    .arrowIcon {
        width: 13px;
        margin-right: 0.5rem;
        margin-left: 0.2rem;
        transform: rotate(180deg);

        &.open {
            transform: rotate(0);
        }
    }
}
